import { GroupedPayload } from "./types";
import { Job } from "@app/models/job";

const threadExists = (threads: GroupedPayload, job: Job) => {
  return threads[job.title];
};

export { threadExists };
